<!-- WatermarkComponent.vue 全局水印 -->
<template>
    <div ref="watermark" class="global-watermark"></div>
</template>

<script>
export default {
    name: 'WatermarkComponent',
    data() {
        return {
            attrObserver: null,
            parentObserver: null,
            container: null,
            // 程序化修改样式期间的防循环标记
            applying: false
        }
    },
    computed: {
        // 水印内容：业务员显示联系人姓名，客户显示公司名称（登录后自动更新）
        watermarkTexts() {
            const texts = []
            // contacter 有值优先使用，否则回退到公司名称
            const busyMember = this.$store.state.busyMemberInfo
            if (busyMember && busyMember.contacter) {
                texts.push(busyMember.contacter)
            } else {
                const member = this.$store.state.memberInfo
                if (member && member.companyName) {
                    texts.push(member.companyName)
                }
            }
            return texts
        }
    },
    watch: {
        watermarkTexts() {
            this.$nextTick(() => this.resetWatermark())
        }
    },
    mounted() {
        this.resetWatermark()
        this.initObservers()
        window.addEventListener('resize', this.resetWatermark)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resetWatermark)
        if (this.attrObserver) this.attrObserver.disconnect()
        if (this.parentObserver) this.parentObserver.disconnect()
    },
    methods: {
        // 生成水印并强制写入必需样式
        resetWatermark() {
            const el = this.$refs.watermark
            if (!el) return

            // 单个水印块尺寸
            const blockWidth = 340
            const blockHeight = 220
            const fontSize = 14
            const dpr = window.devicePixelRatio || 1

            const canvas = document.createElement('canvas')
            canvas.width = blockWidth * dpr
            canvas.height = blockHeight * dpr
            const ctx = canvas.getContext('2d')
            ctx.scale(dpr, dpr)
            ctx.font = `${fontSize}px "Microsoft YaHei", "PingFang SC", sans-serif`
            ctx.fillStyle = 'rgba(0, 0, 0, 0.08)'
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'
            ctx.translate(blockWidth / 2, blockHeight / 2)
            ctx.rotate((-18 * Math.PI) / 180)
            const lineHeight = fontSize + 10
            const startY = -((this.watermarkTexts.length - 1) * lineHeight) / 2
            this.watermarkTexts.forEach((text, index) => {
                ctx.fillText(text, 0, startY + index * lineHeight)
            })

            const dataUrl = canvas.toDataURL('image/png')

            this.applying = true
            const styles = {
                position: 'fixed',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: '99999',
                backgroundImage: `url(${dataUrl})`,
                backgroundRepeat: 'repeat',
                backgroundPosition: '0 0'
            }
            Object.keys(styles).forEach((key) => {
                el.style[key] = styles[key]
            })
            // MutationObserver 回调为微任务，早于 setTimeout 执行，可避免误触发重建
            setTimeout(() => {
                this.applying = false
            }, 0)
        },
        // 防删除、防篡改
        initObservers() {
            const el = this.$refs.watermark
            this.container = el.parentElement

            // 水印自身样式/属性被篡改时立即恢复
            this.attrObserver = new MutationObserver(() => {
                if (this.applying) return
                this.resetWatermark()
            })
            this.attrObserver.observe(el, {
                attributes: true,
                attributeFilter: ['style', 'class']
            })

            // 水印节点被移除时重新挂载回原位置
            if (this.container) {
                this.parentObserver = new MutationObserver(() => {
                    if (!document.body.contains(el)) {
                        this.container.appendChild(el)
                    }
                })
                this.parentObserver.observe(this.container, { childList: true })
            }
        }
    }
}
</script>

<style>
.global-watermark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 99999;
  background-repeat: repeat;
}
</style>
